module.exports = "/_next/static/images/9e1247a7ade29d64d0e12fcf0e3f3f6a-features-meal-xs.jpg.webp";